import { dateFormatConfig } from "@utils/constants";
import { getClientName } from "@utils/helpers";
import { capitalize } from "lodash";
import moment from "moment";

export function getDay(value: any) {
  const date = moment(value);

  const today = moment().startOf("day");

  if (date.isSame(today, "day")) {
    return `Today`;
  } else if (date.isSame(today.clone().subtract(1, "days"), "day")) {
    return `Yesterday`;
  } else if (date.isSame(today.clone().add(1, "days"), "day")) {
    return `Tomorrow`;
  } else {
    // Get the day of the week as an integer (0-6)
    const dayOfWeek = date.day();

    // Use Lodash to get the day name based on the integer value
    const dayName = capitalize(moment.weekdays(dayOfWeek));

    return dayName;
  }
}

export const getContentView = ({ outreach = []}: any) => {
  return (
    <div className="outreach__card__body">
      {outreach.map((d: any) => {
        const { label = '', struct_value = ''}: any = d;
        return (
          <div className={`outreach__card__body__content ${label.toLowerCase().split(' ').join('')}`}>
            <div className="outreach__card__body__content-header">{label}</div>
            <div className={`outreach__card__body__content-value ${label.toLowerCase().split(' ').join('')}`}>
              {moment(struct_value).isValid() ? moment(struct_value).format(dateFormatConfig.get(getClientName())["dateTimeColumnFilterDisplayFormatWithTime"]) : struct_value}
            </div>
          </div>
        );
      })}
    </div>
  );
};

